export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/Sleep_Web_Bottle.d29a408775b1bc1a14ec87c9335374d5.png";